module.exports = __webpack_public_path__ + "img/logo_mo.54ea60d7.png";